import React, { useEffect, useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { format } from 'date-fns';
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import VisibilityIcon from '@mui/icons-material/Visibility';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import { AuthContext } from '../../context/authContext';
import { getEmployees, toggleEmployee, logoutUser } from '../../utilities/sendRequest';
import ExportToExcel from '../../components/Exports/ExportToExcel';
import { formatTanggal } from '../../utilities/helper';

const Employees = () => {
    const { dispatch, user } = useContext(AuthContext)
    const [datas, setDatas] = useState([])
    const [reportActiveDatas, setReportActiveDatas] = useState([])
    const [reportInactiveDatas, setReportInactiveDatas] = useState([])
    const [reportPointDatas, setReportPointDatas] = useState([])
    const [fetchMore, setFetchMore] = useState(true)
    const fileName1 = "Report_Detail_Active_Employees_" + format(new Date(), "yyyy-MM-dd_HH:mm:ss");
    const fileName2 = "Report_Detail_Inactive_Employees_" + format(new Date(), "yyyy-MM-dd_HH:mm:ss");
    const fileName3 = "Report_Point_Active_Employees_" + format(new Date(), "yyyy-MM-dd_HH:mm:ss");

    useEffect(() => {
        fetchEmployees()
        setFetchMore(false)
        
        // eslint-disable-next-line
    }, [fetchMore])

    const fetchEmployees = async () => {
        getEmployees().then((res) => {
            setDatas(
                res.payload.sort((p1, p2) => {
                    return new Date(p2.createdAt) - new Date(p1.createdAt)
                })
            )
                
            let activeTempDatas = res.payload
                                    .filter(item => item.is_active === true)
                                    .sort((p1, p2) => {
                                        return new Date(p2.createdAt) - new Date(p1.createdAt);
                                    })
            
            setReportActiveDatas(
                activeTempDatas.map(item => (
                    { 
                        "Nama Lengkap": item.fullname, 
                        "NIP": item.nip, 
                        "Divisi": item.office,
                        "Email": item.email,
                        "Status": item.type,
                        "Eslon": item.echelon,
                        "Tanggal Masuk": formatTanggal(item.hire_date),

                        "NIK": item.id_card,
                        "Gender": item.gender,
                        "Religion": item.religion,
                        "Tanggal Lahir": formatTanggal(item.birthday),
                        "Tempat Lahir": item.hometown,
                        "Status Perkawinan": item.marital_status,
                        "Pendidikan Terakhir": item.last_education,

                        "Bank": item.bank,
                        "Nomor Rekening": item.bank_account_number,
                        "Pemilik Rekening": item.card_holder,
                        "Phone": item.phone.find(p => p.is_main)?.phone_number ?? "-",
                        "Address": item.address.find(p => p.is_main)?.name ?? "-",
                        "Kode Pos": item.address.find(p => p.is_main)?.postal_code ?? "-",
                        "Kelurahan": item.address.find(p => p.is_main)?.village ?? "-",
                        "Kecamatan": item.address.find(p => p.is_main)?.district ?? "-",
                        "Kota": item.address.find(p => p.is_main)?.city ?? "-",
                        "Provinsi": item.address.find(p => p.is_main)?.province ?? "-",
                        "Shift": item.shift.in + " - " + item.shift.out,
                        "Type Shift": item.shift.crossday ? "Cross Day" : "Same Day",
                        "Status Kepegawaian": item.is_active ? "ACTIVE" : "INACTIVE",
                        "Note HRD": '',
                    })
            ))

            setReportPointDatas(
                [...activeTempDatas] // copy dulu biar tidak mutate state asli
                    .sort((a, b) => b.point - a.point) // point tertinggi di atas
                    .map(item => ({
                    "Nama Lengkap": item.fullname,
                    "NIP": item.nip,
                    "Divisi": item.office,
                    "Point": item.point,
                    "Note": "",
                }))
            );

            let inactiveTempDatas = res.payload
                                    .filter(item => item.is_active === false)
                                    .sort((p1, p2) => {
                                        return new Date(p2.createdAt) - new Date(p1.createdAt);
                                    })
            setReportInactiveDatas(
                inactiveTempDatas.map(item => (
                    { 
                        "Nama Lengkap": item.fullname, 
                        "NIP": item.nip, 
                        "Divisi": item.office,
                        "Email": item.email,
                        "Status": item.type,
                        "Eslon": item.echelon,
                        "Tanggal Masuk": formatTanggal(item.hire_date),

                        "NIK": item.id_card,
                        "Gender": item.gender,
                        "Religion": item.religion,
                        "Tanggal Lahir": formatTanggal(item.birthday),
                        "Tempat Lahir": item.hometown,
                        "Status Perkawinan": item.marital_status,
                        "Pendidikan Terakhir": item.last_education,

                        "Bank": item.bank,
                        "Nomor Rekening": item.bank_account_number,
                        "Pemilik Rekening": item.card_holder,
                        "Phone": item.phone.find(p => p.is_main)?.phone_number ?? "-",
                        "Address": item.address.find(p => p.is_main)?.name ?? "-",
                        "Kode Pos": item.address.find(p => p.is_main)?.postal_code ?? "-",
                        "Kelurahan": item.address.find(p => p.is_main)?.village ?? "-",
                        "Kecamatan": item.address.find(p => p.is_main)?.district ?? "-",
                        "Kota": item.address.find(p => p.is_main)?.city ?? "-",
                        "Provinsi": item.address.find(p => p.is_main)?.province ?? "-",
                        "Shift": item.shift.in + " - " + item.shift.out,
                        "Type Shift": item.shift.crossday ? "Cross Day" : "Same Day",
                        "Status Kepegawaian": item.is_active ? "ACTIVE" : "INACTIVE",
                        "Note HRD": '',
                    })
            ))
            
        }).catch((err) => {
            toast.error(err.message, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });

            if (err.response.status === 401) {
                setTimeout(() => {
                    logoutUser(dispatch)
                }, 2500)
            }
        })
    }

    const handleToggle = (nip) => {
        toggleEmployee(nip).then((res) => {
            toast.success(res.message, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
            setFetchMore(true)
        }).catch((err) => {
            toast.error(err.response.data.message, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });

            if (err.response.status === 401) {
                setTimeout(() => {
                    logoutUser(dispatch)
                }, 3500)
            }
        })
    }

    const columns = [
        { 
            field: 'nip', 
            headerName: 'NIP',
            width: 100, 
            renderCell: (params) => {
                return (
                    <div className='flex justify-center items-center font-ssp'>
                        {params.row.nip}
                    </div>
                )
            } 
        },
        { 
            field: 'office', 
            headerName: 'Office',
            width: 200, 
            renderCell: (params) => {
                return (
                    <div className='flex justify-center items-center font-ssp'>
                        {params.row.office}
                    </div>
                )
            } 
        },
        { 
            field: 'fullname', 
            headerName: 'Fullname',
            width: 200, 
            renderCell: (params) => {
                return (
                    <div className='flex justify-center items-center font-ssp'>
                        {params.row.fullname}
                    </div>
                )
            } 
        },
        { 
            field: 'id_card', 
            headerName: 'NIK',
            width: 150, 
            renderCell: (params) => {
                return (
                    <div className='flex justify-center items-center font-ssp'>
                        {params.row.id_card}
                    </div>
                )
            } 
        },
        { 
            field: 'point', 
            headerName: 'Point',
            width: 100, 
            renderCell: (params) => {
                return (
                    <div className='flex justify-center items-center font-ssp'>
                        {params.row.point ? params.row.point : 0}
                    </div>
                )
            } 
        },
        {
            field: 'type',
            headerName: 'Type',
            width: 150,
            renderCell: (params) => {
                return (
                    <div className='flex justify-center items-center font-ssp'>
                        {params.row.type}
                    </div>
                )
            } 
        },
        {
            field: 'is_active',
            headerName: 'Status',
            width: 110,
            renderCell: (params) => {
                return (
                    <div className="font-ssp">
                        {params.row.is_active
                            ? <span className="px-2 py-1 bg-green-400 rounded-full text-white uppercase">active</span>
                            : <span className="px-2 py-1 bg-red-400 rounded-full text-white uppercase">inactive</span>
                        }
                    </div>
                )
            } 
        },
        {
            field: 'action',
            headerName: 'Action',
            width: 120,
            renderCell: (params) => {
                return (
                    <div className='w-full flex flex-row items-center gap-3'>
                        <Link to={"/employees/" + params.row.nip}>
                            <VisibilityIcon fontSize='medium' className="text-slate-400 hover:text-slate-500 cursor-pointer"/>
                        </Link>
                        {user.is_admin === "admin" || user.is_admin === "superadmin" 
                            ?
                                <>{params.row.is_active
                                    ? <ToggleOnIcon className="text-green-400 hover:text-green-500 cursor-pointer" onClick={() => handleToggle(params.row.nip)}/>
                                    : <ToggleOffIcon className="text-gray-400 hover:text-gray-500 cursor-pointer" onClick={() => handleToggle(params.row.nip)}/>
                                }</>
                            : "" } 
                    </div>
                )
            }
        },
    ]

    return (
        <div className={`min-h-[calc(100vh-4rem)] flex flex-col`}>
            {/* header  */}
            <div className="my-5 mb-5 mx-7 md:mx-5 flex flex-col md:flex-row justify-between">
                <h1 className='font-ssp font-bold text-2xl md:text-3xl'>Employees</h1>
                {user.is_admin === "admin" || user.is_admin === "superadmin"
                    ?
                        <div className='flex flex-col md:flex-row'>
                            <Link to={'/employees/add'} className="px-5 py-2.5 mr-3 mt-3 md:mt-1 bg-blue-400 hover:bg-blue-500 rounded-lg flex text-sm font-medium self-start md:self-end cursor-pointer">
                                <span className='text-sm text-white font-ssp'>Add New</span>
                            </Link>
                            <ExportToExcel reportDatas={reportActiveDatas} fileName={fileName1} label="Download Active Employee" color="bg-yellow-500" />
                            <ExportToExcel reportDatas={reportInactiveDatas} fileName={fileName2} label="Download Inactive Employee" color="bg-gray-500" />
                            <ExportToExcel reportDatas={reportPointDatas} fileName={fileName3} label="Download Point Employee" color="bg-pink-500" />
                        </div>
                    : <div className='flex flex-col md:flex-row'>
                            <ExportToExcel reportDatas={reportPointDatas} fileName={fileName3} label="Download Point Employee" color="bg-pink-500" />
                        </div>
                }
            </div>
            {/* content  */}
            <div className="my-5 mb-5 mx-7 md:mx-5 flex">
                <div className="p-2 w-full bg-white drop-shadow-lg rounded-md flex">
                    <DataGrid
                        autoHeight {...datas}
                        rows={datas}
                        columns={columns}
                        pageSize={15}
                        getRowId={(row) => row.email}
                        rowsPerPageOptions={[15]}
                        checkboxSelection
                        disableSelectionOnClick
                        components={{ Toolbar: GridToolbar, }}
                    />
                </div>
            </div>
        </div>
    )
}

export default Employees